import { Row, Col } from "antd";
import { Typography, Button } from "@mui/material";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { Link } from "react-router-dom";


export const HeaderView = (props) => {
    const { classes, clsx, form, error, customerDetails, changeCustomer, view,
        customerApi, handleProductEdit,
        customObject, idNamingConversion, type, loader } = props;
    return (
        <>
            <Row gutter={50}>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    {
                        view ? <>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer Name </Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customerName || '---'}</Typography>
                        </> :
                            <AutoCompleteComponent
                                name={["Customer Name ", <span key={"Customer Name"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Customer Name' },
                                { 'key': 'mobile', 'name': 'Phone Number' },
                                { 'key': 'serialNo', 'name': 'Customer ID' }]}
                                details={customerDetails}
                                id={idNamingConversion('customerName', 'customerProducts', 'DropDown')}
                                parentValue={customObject(customerDetails, form?.customerId)}
                                onChange={(data) => changeCustomer(data)}
                                searchType={(s) => customerApi(s)}
                                parentError={error?.customerId || false}
                                position={"bottom"}
                                disabled={type !== 'create' ? true : false}
                            />
                    }
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Mobile Number </Typography>
                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.mobile || '---'}</Typography>
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Email </Typography>
                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.email || '---'}</Typography>
                </Col>
                <Col xxl={9} xl={9} lg={9} md={9} sm={12} xs={24} className={classes.textAlignRight}>
                    {
                        view ? <Link onClick={() => handleProductEdit('edit')} to={'#'}
                            className={clsx(classes.AddMoreBtn, classes.bold, classes.marginRight0)}>Edit</Link> : <Button
                                tabIndex={-1}
                                key="Save"
                                type="submit"
                                color="primary"
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: loader })}
                            >{type === 'create' ? 'Save' : 'Update'}</Button>
                    }
                </Col>
            </Row>
        </>
    )
}